import React from 'react'
import {IconProps} from 'types/IconProps'

const PhoneIcon = (props: IconProps) => {
  const {width, height, color} = props
  return (
    <svg
      width={width || '20'}
      height={height || '20'}
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g id='Phone' clipPath='url(#clip0_280_9185)'>
        <path
          id='Vector'
          d='M12.843 11.3544C12.9295 11.2968 13.0291 11.2617 13.1326 11.2523C13.2362 11.2429 13.3404 11.2594 13.4359 11.3005L17.1203 12.9512C17.2445 13.0043 17.3481 13.0962 17.4157 13.2131C17.4833 13.3299 17.5112 13.4656 17.4953 13.5997C17.3739 14.5067 16.9273 15.3389 16.2383 15.9413C15.5494 16.5437 14.6652 16.8754 13.75 16.8747C10.9321 16.8747 8.22957 15.7553 6.23699 13.7627C4.24442 11.7701 3.125 9.0676 3.125 6.24968C3.1243 5.33452 3.456 4.45026 4.05841 3.76134C4.66082 3.07242 5.49293 2.62574 6.4 2.50436C6.53409 2.48844 6.66973 2.51636 6.78662 2.58396C6.90351 2.65156 6.99537 2.7552 7.04844 2.87936L8.69922 6.56686C8.73978 6.66157 8.7563 6.76484 8.7473 6.86748C8.7383 6.97012 8.70407 7.06894 8.64766 7.15515L6.97813 9.1403C6.9189 9.22966 6.88388 9.33286 6.87649 9.43981C6.86909 9.54676 6.88958 9.6538 6.93594 9.75046C7.58203 11.0731 8.94922 12.4239 10.2758 13.0637C10.373 13.1099 10.4805 13.1299 10.5878 13.1218C10.695 13.1138 10.7983 13.0778 10.8875 13.0176L12.843 11.3544Z'
          stroke={color || '#666666'}
          strokeWidth='1.25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_280_9185'>
          <rect width={width || '20'} height={height || '20'} fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export default PhoneIcon
